import React from "react";
import { CheckCircle2 } from "lucide-react";

export const TRUST_BADGES = [
  "AI-assisted",
  "Consultant-validated",
  "Evidence-traceable",
  "Built around published JCA guidance",
  "Board-ready",
  "Confidential engagement",
];

export const TrustBadges = ({ dark = false, className = "" }) => (
  <div className={`flex flex-wrap justify-center gap-x-6 gap-y-2.5 ${className}`} data-testid="trust-badges">
    {TRUST_BADGES.map((t) => (
      <span key={t} className={`inline-flex items-center gap-1.5 text-xs sm:text-sm font-medium ${dark ? "text-slate-300" : "text-slate-600"}`}>
        <CheckCircle2 className={`h-3.5 w-3.5 shrink-0 ${dark ? "text-emerald-400" : "text-emerald-600"}`} /> {t}
      </span>
    ))}
  </div>
);
